import React, { useEffect } from 'react';
import { useAppNavigationContext } from '../../app/features/navigation/providers/AppNavigationProvider';
import PFaqInvestor from './pages/PFaqInvestor';

type FaqProps = {
	page: string;
};
const Faq = (props: FaqProps) => {
	const { page } = props;

	const navigationContext = useAppNavigationContext();
	useEffect(() => {
		if (navigationContext.displayCurrencySelector === true) {
			navigationContext.setDisplayCurrencySelector(false);
		}
	}, [navigationContext]);

	switch (page) {
		case 'investor':
			return <PFaqInvestor />;
		default:
			return <></>;
	}
};

export default Faq;
